<template>
  <l-layer-group
    v-if="points && points.length > 0"
    layer-type="overlay"
    name="Heat Map"
    :visible="true"
  >
    <l-circle
      v-for="(point, i) in points"
      :key="i"
      :lat-lng="[point.satPos.lat, point.satPos.lng]"
      :radius="300000"
      :weight="0"
      :opacity="0.6"
      :fillOpacity="0.05"
      fillColor="yellow"
    />
  </l-layer-group>
</template>

<script setup>
import { computed } from 'vue'
import { LLayerGroup, LCircle } from "vue2-leaflet"

const props = defineProps({
  statistics: {
    type: Array,
    required: true
  }
})

const points = computed(() => {
  if (!props.statistics) return null
  let statisticsPoints = []
  for (const day of props.statistics) {
    if (day.frames) {
      statisticsPoints.push(...day.frames)
    }
  }
  return statisticsPoints
    .filter(p => p.satPos && p.satPos.lat != null && p.satPos.lng != null)
    .slice(0, 2000)
})
</script>